var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.notifications.get()),function(notification,index){return _c('li',{key:index},[_c('toast',{attrs:{"text":notification.text,"type":notification.type,"fade-seconds":0.5,"show-seconds":_vm.getShowSeconds(notification, index)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }